export default "__VITE_ASSET__llDe_Sb4__"